import { render, staticRenderFns } from "./StepPregnancy.vue?vue&type=template&id=f8b9364a&"
import script from "./StepPregnancy.vue?vue&type=script&lang=js&"
export * from "./StepPregnancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports